import React, { } from 'react'
import { Outlet } from 'react-router-dom'


function LiveRoomStructur() {
    return (
        <div className="frame">
            <div className='light-yellow' style={{ paddingTop: "0px" }}>

                <section  >
                    <Outlet />
                </section>
            </div>
        </div>
    )
}

export default LiveRoomStructur
